import axios from 'axios'
import { API_URL, CUSTOMERS_KEY } from '../keys'
import {
	CreateCustomerEntity,
	LoginModel,
} from '@/entities/api/customers/customer'

const BASE_URL = `${API_URL}/auth`

const defaultHeaders = {
	'sce-api-key': CUSTOMERS_KEY,
	'Content-Type': 'application/json',
}

const defaultConfig = {
	headers: defaultHeaders,
	validateStatus: (status: number) => status < 500,
}

export const loginLocal = async (data : { email : string, password : string}) => {
	const response = await axios.post(
		`${BASE_URL}/login/local`,
		data,
		defaultConfig
	)
	return response
}

export const verifyLoginCode = async (code: number) => {
	const response = await axios.post(
		`${BASE_URL}/login/verify`,
		{ code },
		defaultConfig
	)
	return response
}

export const verifyToken = async (token: string) => {
	const response = await axios.post(
		`${BASE_URL}/token/verify`,
		{ token },
		defaultConfig
	)
	return response
}

export const sendLoginCode = async (email: string) => {
	const response = await axios.get(
		`${BASE_URL}/session/code/send/${email}`,
		defaultConfig
	)
	return response
}

export const changePasswordWithCode = async (
	code: number,
	data: LoginModel
) => {
	const response = await axios.patch(
		`${BASE_URL}/session/change/password/${code}`,
		data,
		defaultConfig
	)
	return response
}
export const sendVerifyEmailCode = async (email: string) => {
	const response = await axios.get(
		`${BASE_URL}/verify/email/code/send/${email}`,
		defaultConfig
	)
	return response
}

export const verifyEmailCode = async (code: number) => {
	const response = await axios.get(
		`${BASE_URL}/verify/email/code/${code}`,
		defaultConfig
	)
	return response
}

export const registerCustomer = async (data: CreateCustomerEntity) => {
	const response = await axios.post(
		`${BASE_URL}/secure/register`,
		data,
		defaultConfig
	)
	return response
}

export const getCustomerByEmail = async (email: string, token: string) => {
	const response = await axios.get(`${API_URL}/customers/${email}`, {
		...defaultConfig,
		headers: {
			...defaultHeaders,
			Authorization: `Bearer ${token}`,
		},
	})
	return response
}
